import React from 'react'

const YouTubeIframe = ({ videoId, width, height, url }) => {
    return (
        <iframe
            title="Video embed"
            width={width}
            height={height}
            src={url ? url : `https://www.youtube-nocookie.com/embed/${videoId}`}
            frameBorder="0"
            allow="encrypted-media"
            allowFullScreen
            style={{ marginTop: url ? '68px' : '0px', height: height }}
        ></iframe>
    )
}

YouTubeIframe.defaultProps = {
    width: '100%',
    height: '100%',
}

export default YouTubeIframe
